/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ domain: NonNullable<unknown> }} Domain_Updated_AuditInputs */

const en_domain_updated_audit = /** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Custom domain updated to: ${i?.domain}`)
};

const es_domain_updated_audit = /** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dominio personalizado actualizado a: ${i?.domain}`)
};

const fr_domain_updated_audit = /** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Domaine personnalisé mis à jour vers : ${i?.domain}`)
};

const de_domain_updated_audit = /** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Domain aktualisiert auf: ${i?.domain}`)
};

const id_domain_updated_audit = /** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Domain kustom diperbarui ke: ${i?.domain}`)
};

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const ja_domain_updated_audit = en_domain_updated_audit;

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const zh_domain_updated_audit = en_domain_updated_audit;

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const ar_domain_updated_audit = en_domain_updated_audit;

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const it_domain_updated_audit = en_domain_updated_audit;

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const ru_domain_updated_audit = en_domain_updated_audit;

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const pt_domain_updated_audit = en_domain_updated_audit;

/** @type {(inputs: Domain_Updated_AuditInputs) => LocalizedString} */
const ko_domain_updated_audit = en_domain_updated_audit;

/**
* | output |
* | --- |
* | "Custom domain updated to: {domain}" |
*
* @param {Domain_Updated_AuditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_updated_audit = /** @type {((inputs: Domain_Updated_AuditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Updated_AuditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_updated_audit(inputs)
	if (locale === "es") return es_domain_updated_audit(inputs)
	if (locale === "fr") return fr_domain_updated_audit(inputs)
	if (locale === "de") return de_domain_updated_audit(inputs)
	if (locale === "ja") return ja_domain_updated_audit(inputs)
	if (locale === "zh") return zh_domain_updated_audit(inputs)
	if (locale === "ar") return ar_domain_updated_audit(inputs)
	if (locale === "id") return id_domain_updated_audit(inputs)
	if (locale === "it") return it_domain_updated_audit(inputs)
	if (locale === "ru") return ru_domain_updated_audit(inputs)
	if (locale === "pt") return pt_domain_updated_audit(inputs)
	return ko_domain_updated_audit(inputs)
});